/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import ErrorMessage from '../../../../share/ErrorMessage'
import { getFilteredInsightDataSet } from '../utils'
import { SentimentWidgetsType } from '../../types'
import { InsightCount } from '../../../../../schemas/action/InsightCountSchema'

interface SentimentEmptyResultGuardProps {
  widgetId: number
  children: React.ReactElement
}

const SentimentEmptyResultGuard = ({
  widgetId,
  children
}: SentimentEmptyResultGuardProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<SentimentWidgetsType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const sum = getFilteredInsightDataSet(widgetData, widgetSetting)
    .map((entry) => entry.value)
    .reduce((prev, curr) => prev! + curr!, 0)

  if (!sum) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default SentimentEmptyResultGuard
